module.exports = __webpack_public_path__ + "assets/img/tabs-home-6ef194e3.png";